var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('button',{staticClass:"redesign-toggle-btn",class:_setup.buttonClasses,style:(_setup.buttonStyles),on:{"click":_setup.toggle}},[_vm._v("\n        "+_vm._s(_setup.isActive ? _vm.onLabel : _vm.offLabel)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }